import { z } from 'zod';
/** Langues servies par un site de galerie (D15, section 4.2). */
export const LANGUES = ['fr', 'en'];
export const LangueSchema = z.enum(LANGUES);
/**
 * Texte bilingue (section 4.2) : le français est obligatoire, l'anglais
 * facultatif. Le site affiche le français quand l'anglais manque, et le
 * `hreflang` de la page reste correct : la page anglaise existe, elle est
 * simplement partiellement en français.
 */
export const TexteBilingueSchema = z.object({
    fr: z.string().min(1),
    en: z.string().min(1).optional(),
});
/** Texte bilingue long (paragraphes séparés par une ligne vide). */
export const ProseBilingueSchema = TexteBilingueSchema;
/** Repli sur le français quand la traduction manque (section 4.2). */
export function texte(valeur, langue) {
    if (langue === 'fr')
        return valeur.fr;
    return valeur.en ?? valeur.fr;
}
/** Repli sur le français, pour un texte facultatif. */
export function texteFacultatif(valeur, langue) {
    return valeur === undefined ? undefined : texte(valeur, langue);
}
/** La langue réellement écrite pour ce texte, pour un `lang=` local juste. */
export function langueDuTexte(valeur, langue) {
    return langue === 'en' && valeur.en === undefined ? 'fr' : langue;
}
/** Découpe une prose en paragraphes (lignes vides). */
export function paragraphes(valeur) {
    return valeur
        .split(/\n\s*\n/)
        .map((p) => p.trim())
        .filter((p) => p.length > 0);
}
/**
 * Slug : identifiant d'URL stable (section 4.2). Jamais recalculé après
 * publication ; un changement de titre crée une redirection.
 */
export const SlugSchema = z
    .string()
    .min(1)
    .max(120)
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'slug invalide : minuscules, chiffres et tirets');
/** Date civile ISO `AAAA-MM-JJ`. */
export const DateCivileSchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'date attendue au format AAAA-MM-JJ');
/** Horodatage ISO 8601 complet. */
export const HorodatageSchema = z.iso.datetime({ offset: true });
/** Heure `HH:MM`. */
export const HeureSchema = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'heure attendue HH:MM');
/** Couleur hexadécimale `#RRGGBB`. */
export const CouleurSchema = z
    .string()
    .regex(/^#[0-9a-fA-F]{6}$/, 'couleur attendue au format #RRGGBB');
//# sourceMappingURL=textes.js.map